import {ISlsOrd, ISlsOrdClient, ISlsOrdResponse} from "../kova/slsordClient";
import {createContext, useContext, useEffect, useState} from "react";
import {ReservationClient} from "./reservationClient";
import {useUserContext} from "../context/userContext";
import useStation from "./stationSource";


export class SlsOrdSource {
    constructor(private readonly client:ISlsOrdClient) {

    }

    async getSlsOrds(customerId?: number) {
        return this.client.getSlsOrds(customerId);
    }
    async getCommunityInfo(customerId?: number) {
        return this.client.getCommunityInfo(customerId);
    }
}


export const SlsOrdSourceContext = createContext<SlsOrdSource|null>(null);
export const ReservationClientContext = createContext<ReservationClient|null>(null);


export function useSlsOrdSource() {

    const slsOrdSource = useContext(SlsOrdSourceContext);
    if (slsOrdSource === null) throw new Error("SlsOrdSource is not defined");
    return slsOrdSource;
}

const RefreshInterval = 10000;


export function useReservationClient() {
    const reservationClient = useContext(ReservationClientContext);
    if (reservationClient === null) throw new Error('ReservationClient not defined');
    return reservationClient;
}

export function useSlsOrds() {
    const { communityInfo, refresh } = useCommunityInfo();
    return { slsOrds: communityInfo?.homes ?? null, refresh };

}
/**
 * Basically always returns an updated list of SlsOrds. Triggers re-render when the SlsOrds change.
 * (and also every second just because this has not been optimized)
 *
 */
export function useCommunityInfo() {
    const slsOrdSource = useSlsOrdSource();
    const userContext = useUserContext();
    const station = useStation();
    const [communityInfo, setCommunityInfo] = useState<ISlsOrdResponse|null>(null);


    function doUpdate(isStillUpdating: () => boolean) {
        return slsOrdSource.getCommunityInfo(userContext.user?.id).then(so => {
            if (isStillUpdating()) {
                setCommunityInfo(oldSlsOrds => {
                    const oldSlsOrdsJson = JSON.stringify(oldSlsOrds);
                    const newSlsOrdsJson = JSON.stringify(so);
                    if (oldSlsOrdsJson !== newSlsOrdsJson) {
                        console.log('slsords have changed');
                        return so;
                    }
                    return oldSlsOrds;

                })

            }
        })
    }

    useEffect(() => {
        console.log('mounting effect');
        let isStillUpdating = true;
        function update() {
            doUpdate(() => isStillUpdating).catch(err => {
                console.error(err);
            }).finally(() => {
                if (isStillUpdating) {
                    setTimeout(update, RefreshInterval);
                }
            });
        }
        update();
        return () => { console.log('unmounting effect'); isStillUpdating = false; };

    }, [slsOrdSource])
    return { communityInfo, refresh: () => doUpdate(() => true) };
}


